<template>
  <div id="app">
    <router-view v-if="!showBackOnline" />
    <offline-page v-else />
  </div>
</template>

<script>
import offlinePage from './components/OfflinePage';

export default {
  name: 'app',
  components : {
    'offline-page' : offlinePage
  },
  data : () => ({
    onLine: navigator.onLine,
    showBackOnline: false
  }),
  watch: {
    onLine(v) {
        if (v) {
            this.showBackOnline = true;
            setTimeout(() => {
                this.showBackOnline = false;
            }, 1000);
        }
    }
  },
  methods : {
    updateOnlineStatus(e) {
      const {
          type
      } = e;
      this.onLine = type === 'online';
    }
  },
  mounted(){
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeDestroy() {
      window.removeEventListener('online', this.updateOnlineStatus);
      window.removeEventListener('offline', this.updateOnlineStatus);
  }
}
</script>

<style>
body{
  width: 100vw;
  height: 100vh;
  /* min-height: 100vh; */

  /* min-height: 570px; */

  margin: 0;
}

h1, p{
  margin: 0;
}

/* @media (max-width: 320px){
    html, body{
        min-height: 520px;
    }
} */

@font-face {
    font-family: 'HelveticaNeueCyr';
    src: url('./assets/fonts/HelveticaNeueCyr-Medium.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueCyr-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueCyr';
    src: url('./assets/fonts/HelveticaNeueCyr-Roman.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueCyr-Roman.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueCyr';
    src: url('./assets/fonts/HelveticaNeueCyr-Bold.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueCyr-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueCyr';
    src: url('./assets/fonts/HelveticaNeueCyr-Black.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueCyr-Black.woff') format('woff');
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueCyr';
    src: url('./assets/fonts/HelveticaNeueCyr-Light.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueCyr-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
}

/* @font-face {
    font-family: 'HelveticaNeueLTStd';
    src: url('./assets/fonts/HelveticaNeueLTStd-Md.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueLTStd-Md.woff') format('woff');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueLTStd';
    src: url('./assets/fonts/HelveticaNeueLTStd-Ex.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueLTStd-Ex.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueLTStd';
    src: url('./assets/fonts/HelveticaNeueLTStd-BdEx.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueLTStd-BdEx.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueLTStd';
    src: url('./assets/fonts/HelveticaNeueLTStd-BlkEx.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueLTStd-BlkEx.woff') format('woff');
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: 'HelveticaNeueLTStd';
    src: url('./assets/fonts/HelveticaNeueLTStd-Lt.woff2') format('woff2'),
        url('./assets/fonts/HelveticaNeueLTStd-Lt.woff') format('woff');
    font-weight: 300;
    font-style: normal;
} */

#app {
  width: 100%;
  height: 100%;

  font-family: 'HelveticaNeueCyr';
  font-weight: normal;
  font-style: normal;
  /* font-family: Arial, Helvetica, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
